<template>
    <section id="hero-section" class="h-screen h-100 bg-cover bg-right md:bg-center bg-no-repeat" :style="getStyles()">
        <div 
            class="lg:content-center m-auto text-center mt-10 xl:mt-0 pt-5 xl:pt-0 my-auto mx-auto h-full w-full md:w-1/2 px-4 md:px-0" 
            :class="context.isDarkMode ? 'text-silver' : 'text-void'"
        >
            <h1 class="text-2xl md:text-4xl lg:text-6xl xl:text-7xl xl:text-4xl 2xl:text-7xl font-bold">{{ translationHandler.translate('we transform ideas into digital reality', 'ucfirst') }}</h1>
            <p class="mt-6 mb-10 text-lg md:text-xl 2xl:text-2xl" :class="context.isDarkMode ? 'text-main-gray' : 'text-semidark-silver'">
                {{ translationHandler.translate('modern, agile, and efficient web development.', 'ucfirst') }}
            </p>
            <div class="flex justify-center items-center flex-col md:flex-row px-5 md:px-0 gap-10">
                <div class="flex gap-2 content-center primary-button max-width-md grow-effect rounded-3xl px-4 shadow" @click="goToSection('service')">
                    <span class="text-lg lg:text-lg 2xl:text-2xl my-auto text-silver font-semibold mx-auto md:mx-0">
                        {{ translationHandler.translate('learn more', 'capitalize') }}
                    </span>
                    <i class="text-silver pi pi-objects-column border border-second-color rounded-full bg-second-color p-2 my-auto shadow"></i>
                </div>

                <div class="flex gap-2 content-center cursor-pointer justify-center shadow md:shadow-none rounded-3xl py-2 px-2 md:px-0 md:py-0 max-width-md" @click="goToBudget()">
                    <i class="text-silver pi pi-chevron-right border border-second-color rounded-full bg-second-color p-2 my-auto shadow"></i>
                    <span class="text-lg lg:text-lg 2xl:text-2xl my-auto underline font-semibold" :class="context.isDarkMode ? 'text-silver' : 'text-void'">
                        {{ translationHandler.translate('get started', 'capitalize') }}
                    </span>
                </div>
            </div>
            <div 
                class="mt-10 pt-5 flex flex-wrap justify-center gap-2 lg:gap-5 border-t-2 md:justify-center"
                :class="context.isDarkMode ? 'border-main-gray' : 'border-silver'"
            >
                <div class="trigger-hero-el flex py-2 px-4 rounded-3xl shadow hover:bg-third-color hover:text-silver hover:font-semibold transition-colors cursor-pointer enlarge-top-effect items-center" v-for="(benefit, index) of benefits" :key="index">
                    <i :class="benefit.icon" class="mr-2"></i>
                    {{ translationHandler.translate(benefit.message, 'ucfirst') }}
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    import translationHandler from '@/composables/handlers/TranslationHandler';
    import urlHandler from '@/composables/urlHandler';
    import { useContextStore } from '@/stores/context';
    import { onMounted, ref } from 'vue';
    import animationHandler from '@/composables/handlers/AnimationHandler';

    const context = useContextStore();
    onMounted(() => {
        handleAnimation();
    });

    const benefits = ref([
        {icon: 'pi pi-bolt', message: 'fast'},
        {icon: 'pi pi-palette', message: 'aesthetic'},
        {icon: 'pi pi-mobile', message: 'flexible'},
        {icon: 'pi pi-shield', message: 'secure'}
    ]);

    function getStyles() {
        const backgroundImage = require(`@/assets/images/main_bg_${context.isDarkMode ? 'dark' : 'light'}.png`);
        return {
            'background-image': `url(${backgroundImage})`,
            'margin-top': '-15px'
        };
    }

    function goToBudget() {
        urlHandler.redirect('/budget');
    }

    async function handleAnimation() {
        const data = [
            {
                mainClass: 'trigger-hero-el',
                classesToUse: ['enforce-enlarge-top-effect', 'bg-third-color', 'text-silver', 'font-semibold'],
                startInterval: 500,
                intervalPerAction: 400,
                triggerAt: '#hero-section'
            }
        ];
        (new animationHandler(data)).watchScrollAndAnimate();
    }

    function goToSection(sectionName = '') {
        urlHandler.redirect({
            name: '', 
            query: {
                section: `${sectionName}-section`
            }
        });
    }
</script>